import React from 'react';
import { DataProvider, useDataContext } from './response-context';
import AppVocationOneReport from '../AppVocationOne';
import AppVocationJuniorReport from '../AppVocationJunior';
import AppVocationStartReport from '../AppVocationStart';

// Clon de SwitchPage para /tuvocacion/r/:id?t=<firma> — mismos componentes de
// reporte, datos desde la API interna de tuvocación vía el worker.

const SwitchPage = props => {
  const { response, isLoading } = useDataContext();

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (!response && !isLoading) {
    return <div>Not found</div>;
  }
  const { campaign, data } = response;
  if (campaign.SKU === 'VOCATION_ONE') {
    return (
      <AppVocationOneReport
        campaign={campaign}
        response={response}
        data={data}
      />
    );
  }

  if (campaign.SKU === 'VOCATION_JUNIOR') {
    return (
      <AppVocationJuniorReport
        campaign={campaign}
        response={response}
        data={data}
      />
    );
  }

  if (campaign.SKU === 'VOCATION_START') {
    return (
      <AppVocationStartReport
        campaign={campaign}
        response={response}
        data={data}
      />
    );
  }

  return (
    <div>
      <div>{response.id}</div>
    </div>
  );
};

const DataWrapper = props => {
  const query = new URLSearchParams(props.location.search);
  return (
    <DataProvider id={props.match.params.id} sig={query.get('t')}>
      <SwitchPage {...props} />
    </DataProvider>
  );
};
export default DataWrapper;
